
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[client]/print/minutes/[id]",
      function () {
        return require("private-next-pages/[client]/print/minutes/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[client]/print/minutes/[id]"])
      });
    }
  